import { NextPage, GetServerSideProps } from 'next'
import { SSRConfig } from 'next-i18next'

export * from './auth'
export * from './convergence'
export * from './country'
export * from './state'
export * from './dispute'
export * from './cardScan'
export * from './identity'
export * from './consumer'

export type ConsumerPage<T = {}> = NextPage<T & SSRConfig> & {
  getLayout?: (page: any) => JSX.Element
}

export * from '@afterpaytouch/portal-api/types'
export { isPortalAxiosError } from '@afterpaytouch/portal-api/utils'

export type ConsumerProps<T> = T & SSRConfig

export type GetConsumerSSP<T = {}> = GetServerSideProps<ConsumerProps<T>>
